import Vue from 'vue'
import Vuex from 'vuex'
Vue.use(Vuex)

const state = {
  sidebarShow: true,
  sidebarMinimize: false,

  isLoggedIn: !!localStorage.getItem("token"),
  isLog: !!localStorage.getItem("token"),
  baseURL: 'https://api.saveanimals.in/',
  // baseURL: 'https://4p77ff62-3902.inc1.devtunnels.ms/',
  // baseURL: 'http://localhost:3902/',
  // baseURL : 'http://192.168.47.195:3902/',

  token: localStorage.getItem("token"),
  // Original Code
  // user : JSON.parse(localStorage.getItem("user")),
  // Code after error
  user: JSON.parse(localStorage.getItem("user")) || { role: "Guest" },
  filters: {
    sourceIntervalType: 'range',
    sourceType: 'admission',
    date: null,
    startDate: null,
    endDate: null,
    outcome: null,
    zone: [],
    class: null,
    family: null,
    group: null,
    identity: null,
    caseno: null,
    scientific: null,
    stage: null,
    facility: null,
    secondFacility: null,
    placeOfRescue: [],
    placeOfRescueText: "",
    placeofOctm: "",
    placeOfReleaseText: "",
    causeOfDisp: [],
    month: null,
    year: null,
  }
}

const mutations = {
  toggleSidebarDesktop(state) {
    const sidebarOpened = [true, 'responsive'].includes(state.sidebarShow)
    state.sidebarShow = sidebarOpened ? false : 'responsive'
  },
  toggleSidebarMobile(state) {
    const sidebarClosed = [false, 'responsive'].includes(state.sidebarShow)
    state.sidebarShow = sidebarClosed ? true : 'responsive'
  },
  set(state, [variable, value]) {
    state[variable] = value
  },
  loginUser(state, payload) {
    state.isLoggedIn = true
    state.isLog = true
    state.token = payload.token;
    state.user = payload.user;
    // Persist to localStorage to ensure session stays active on refresh
    localStorage.setItem("token", payload.token);
    localStorage.setItem("user", JSON.stringify(payload.user));
  },
  logoutUser(state) {
    state.isLoggedIn = false
    state.isLog = false
    state.token = null
    state.user = null
    // Clear localStorage on logout
    localStorage.removeItem("token");
    localStorage.removeItem("user");
  },
  updateFilter(state, payload) {
    state.filters = {
      sourceIntervalType: payload.sourceIntervalType,
      sourceType: payload.timeType,
      date: payload.date,
      startDate: payload.startDate,
      endDate: payload.endDate,
      outcome: payload.outcome,
      zone: payload.zone,
      class: payload.class,
      family: payload.family,
      group: payload.group,
      identity: payload.identity,
      caseno: payload.caseno,
      scientific: payload.scientific,
      stage: payload.stage,
      facility: payload.facility,
      secondFacility: payload.secondFacility,
      placeOfRescue: payload.placeOfRescue,
      placeOfReleaseText: payload.placeOfReleaseText,
      placeOfRescueText: payload.placeOfRescueText,
      placeofOctm: payload.placeofOctm,
      causeOfDisp: payload.causeOfDisp,
      month: payload.month,
      year: payload.year,
    }
    console.log("haii store", state.filters)

  }
}

export default new Vuex.Store({
  state,
  mutations
})